<script>
  export let temp;
  export let pressure;
  export let humidity;
</script>

<div class="container">
  <span class="pressure">
    {pressure}hPa
  </span>
  <span class="temp">
    {temp}°C
  </span>
  <span class="humidity">
    {humidity}%
  </span>
</div>

<style lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
  }
  .temp {
    font-size: 8vmin;
  }
  .pressure,
  .humidity {
    margin: 2vmin;
    font-size: 4vmin;
  }
</style>
